import { useField } from "formik";

import {
  NumberField,
  NumberFieldProps,
} from "../components/inputs/number-field/NumberField";

interface Props extends NumberFieldProps {
  name: string;
}

export function NumberFieldFormikField(props: Props) {
  const {
    name,
    testID,
    label,
    info,
    step,
    maxValue,
    minValue,
    defaultValue,
    description,
    isDisabled,
    isReadOnly,
    isRequired,
    onChange,
  } = props;
  const [field, meta, helpers] = useField(name);

  return (
    <NumberField
      testID={testID}
      label={label}
      info={info}
      step={step}
      maxValue={maxValue}
      minValue={minValue}
      defaultValue={defaultValue}
      description={description}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
      isInvalid={Boolean(meta.touched && meta.error)}
      errorMessage={meta.touched ? meta.error : undefined}
      onBlur={() => helpers.setTouched(true)}
      value={field.value}
      onChange={(value: number) => {
        helpers.setValue(value);
        onChange?.(value);
      }}
    />
  );
}
